import React, { useState } from "react";
import { Form, Input, Button, Checkbox, Col, message } from "antd";
import { NavLink, useNavigate } from "react-router-dom";
import { loginUser } from "../../api/api";
import { useDispatch } from "react-redux";
import useAuthSync from "../../utils/hook/useAuthSync";
import { requestFirebaseNotificationPermission } from "../../utils/pushNotification";
import { sentFirebaseToken } from "../../utils/utils";
import { setFcmToken } from "../../app/slice/chatSlice";

const LoginComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { login } = useAuthSync();
  function onClick() {
    navigate("/auth/demo-request/");
  }

  const onFinish = async (values) => {
    try {
      setIsLoading(true);
      const data = await loginUser({
        email: values.email,
        password: values.password,
      });
      if (data.data.access) {
        const token = await requestFirebaseNotificationPermission();
        dispatch(setFcmToken(token))
        console.log(token, 'token 009')
        await login(data.data)
        await sentFirebaseToken(token);
        message.success("Login Successful", 3);
        setIsLoading(false);
        // return (window.location.href = "/admin/dashboard");
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err, '005')
      message.error(err.message);
      setIsLoading(false);
      return err.message;
    }
  };

  return (
    <div className="glass-card  shadow-lg rounded-lg p-10 w-full max-w-lg h-full">
      <h1 className="text-center text-2xl text-white font-bold mb-6">Login</h1>


      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item name="email" label="Email Address" rules={[{ required: true, message: "Please enter your email!" }]}>
          <Input type="email" placeholder="johndoe@gmail.com" />
        </Form.Item>

        <Form.Item name="password" label="Password" rules={[{ required: true, message: "Please enter your password!" }]}>
          <Input.Password placeholder="********" />
        </Form.Item>

        <Form.Item name="remember" valuePropName="checked" className="mb-4">
          <Checkbox className="">Remember me</Checkbox>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            block
            style={{ backgroundColor: "#122253", borderColor: "#122253", borderRadius: "8px", height: "40px" }}
          >
            Login
          </Button>
        </Form.Item>

        <div className="flex flex-col sm:flex-row justify-between text-sm">
          <p>
            Don't have an account?{" "}
            <NavLink to="/auth/signup/" className="text-[#122253] font-semibold">
              SIGN UP
            </NavLink>
          </p>
          <p>
            <NavLink to="/auth/forgot-password/" className="text-[#122253] font-semibold">
              Forgot Password
            </NavLink>
          </p>
        </div>
        <div className="flex justify-center items-center mt-6 w-full">
          <button
            className="glass-card text-[#122253] px-3 py-2" onClick={onClick} >Request a Demo</button>
        </div>
      </Form>
    </div>
  );
};

export default LoginComponent;
